import Widow from 'widow-js';
import '../styles/index.scss';
import '../styles/mobile.css';
import './ecosystem.js';
import './loadins.js';
import './contact.js';
import './subnav.js';


function clickHandler(event) {
	let target = event.target;
	let urlToOpen = target.closest('[data-target-url')
	if (urlToOpen) {
    event.preventDefault();
		window.open(urlToOpen.getAttribute('data-target-url'), '_blank')
	}
}

document.addEventListener('click', clickHandler, false);


function openMenu() {
  d3.select('nav').classed('open', true);
  d3.select('.nav__logo').attr('src', '/wp-content/themes/accelered/views/logos/UMGC_ID_NEG_031422_1500.svg')
  d3.select('#mobile-menu-button-js #top-bar').transition()
    .attr('y', "38")
    .attr('transform', 'rotate(45, 50, 38)')
  d3.select('#mobile-menu-button-js #bottom-bar').transition()
    .attr('y', "38")
    .attr('transform', 'rotate(-45, 50, 38)')
  d3.select('#mobile-menu-button-js #middle-bar').transition()
    .attr('height', 0)
}

function closeMenu() {
 d3.select('nav').classed('open', false);
 d3.select('.nav__logo').attr('src', '/wp-content/themes/accelered/static/UMGC_ID_POS_031422_1500.svg')
 d3.select('#mobile-menu-button-js #top-bar').transition()
   .attr('y', "0")
   .attr('transform', 'rotate(0)')
 d3.select('#mobile-menu-button-js #bottom-bar').transition()
   .attr('y', "60")
   .attr('transform', 'rotate(0)')
 d3.select('#mobile-menu-button-js #middle-bar').transition()
   .attr('height', 5)
}

function handleMenuClick() {
  if ( d3.select('nav').classed('open') ) {
    closeMenu();
  } else {
    openMenu();
  }
}

var mobileMenuButton = document.getElementById('mobile-menu-button-js');
mobileMenuButton.addEventListener('click', handleMenuClick);


//Accordion
var btnAcc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < btnAcc.length; i++) {
  btnAcc[i].addEventListener("click", function() {
    var bioTxt = this.previousElementSibling;
		var accTxt = this.querySelector('.accordion-text');
    if (accTxt.innerText == "MORE") {
		  this.querySelector('img').src = '/wp-content/themes/accelered/src/icons/AccelerED_BioButtons_Minus.svg';
		  accTxt.innerText = 'LESS';
      bioTxt.style.height = bioTxt.scrollHeight + "px";
    } else {
      this.querySelector('img').src = '/wp-content/themes/accelered/src/icons/AccelerED_BioButtons_Plus.svg';
      accTxt.innerText = 'MORE';
      bioTxt.style.height = 0;
    }
  });
}

const widow = new Widow({words: 2, elements: '.home-tile__text, h1, .service-description p', warnings: true});
